import React from 'react';
import PropTypes from 'prop-types';
import Text from 'ls-common-client/src/components/Text';

const H2 = ({ children, ...props }) => (
  <Text
    marginBottom="18px"
    fontSize="18px"
    fontWeight="600"
    lineHeight="1.2"
    display="block"
    color="normal"
    {...props}
  >
    {children}
  </Text>
);

H2.propTypes = {
  children: PropTypes.node,
};

H2.defaultProps = {
  children: null,
};

export default H2;
